import { FormDataView } from "./FormData";

export default function Census() {
  return <FormDataView templateId="tpl_census" eyebrow="Frigate" />;
}
